import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BulkUpdateTasks } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from '@fluentui/react-components';
import { ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';

const BulkPriorityUpdateMenu = ({ selectedRows, onBulkUpdateComplete, children }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleBulkPriorityChange = async priority => {
        if (!selectedRows || selectedRows.length === 0) return;

        setIsUpdating(true);
        try {
            // Update all selected tasks with the new priority using bulk update
            await dispatch(
                BulkUpdateTasks({
                    taskIds: selectedRows,
                    updates: { priority: priority },
                    suppressToast: true,
                }),
            );

            // Call the completion callback
            if (onBulkUpdateComplete) {
                onBulkUpdateComplete(priority, selectedRows.length);
            }

            setOpen(false);
        } catch (error) {
            console.error('Error updating bulk task priorities:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>
                {children || (
                    <div className={styles.bulkUpdateMenu} style={{ opacity: isUpdating ? 0.6 : 1 }}>
                        Priority <ChevronDown12Regular className="ms-1" />
                    </div>
                )}
            </MenuTrigger>
            <MenuPopover style={{ width: '117px', minWidth: '117px' }}>
                <MenuList>
                    <MenuItem
                        className={styles.priorityMenuItem}
                        onClick={() => handleBulkPriorityChange('HIGH')}
                        style={{ backgroundColor: '#2B35AF', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        High
                    </MenuItem>
                    <MenuItem
                        className={styles.priorityMenuItem}
                        onClick={() => handleBulkPriorityChange('MEDIUM')}
                        style={{ backgroundColor: '#4361EE', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Medium
                    </MenuItem>
                    <MenuItem
                        className={styles.priorityMenuItem}
                        onClick={() => handleBulkPriorityChange('LOW')}
                        style={{ backgroundColor: '#4895EF', color: 'white', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        Low
                    </MenuItem>
                    <MenuItem
                        className={styles.priorityMenuItem}
                        onClick={() => handleBulkPriorityChange('')}
                        style={{ backgroundColor: '#FFFFFF', color: '#989BAD', border: '1px solid #DDDEE4', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer' }}>
                        None
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default BulkPriorityUpdateMenu;
